import { render, staticRenderFns } from "./SalesCommissions.vue?vue&type=template&id=7c6e3862&web=true&"
import script from "./SalesCommissions.vue?vue&type=script&lang=ts&"
export * from "./SalesCommissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports